'use client'

import { useEffect, useMemo, useState } from 'react'
import { useMutation } from '@tanstack/react-query'
import { type ServerStateSummary } from 'lib/mcApi/Types'
import serverStateSummaryAction from './serverStateSummaryAction'

const MUTATION_SCOPE = { id: 'serverStateSummaryAction' }

export default function useServerStateSummary() {
  const [serverStateSummary, setServerStateSummary] = useState<ServerStateSummary | null>(null)

  const {
    mutate,
    isPending,
    isSuccess,
    isError,
    error,
  } = useMutation({
    gcTime: 0,
    scope: MUTATION_SCOPE,
    mutationFn: () => serverStateSummaryAction(),
    onSuccess: (data) => {
      if (data instanceof Error) {
        setServerStateSummary(null)
      } else {
        setServerStateSummary(data)
      }
    },
  })

  useEffect(() => {
    mutate()
  }, [mutate])

  return useMemo(() => ({
    serverStateSummary,
    isPending,
    isError,
    isSuccess,
    refetch: mutate,
    error,
  }), [serverStateSummary, isPending, isError, isSuccess, mutate, error])
}
